module.exports = __webpack_public_path__ + "media/location-service_en_ipad_old.94eab16f.mp4";